export enum WorkoutRecordingMethod {
    GEOFENCE = 'GEOFENCE',
    GPS = 'GPS',
    ACCELEROMETER = 'ACCELEROMETER'
}

declare module '../../core/api/FitnessActivityClient' {
    interface ActivityPointsMultiplierTierGroupDto {
        recordingMethod?: WorkoutRecordingMethod;
    }

    interface ActivityPointsMultiplierTierGroupCreateRequestDto {
        recordingMethod?: WorkoutRecordingMethod;
    }

    interface ActivityPointsMultiplierTierGroupUpdateRequestDto {
        recordingMethod?: WorkoutRecordingMethod;
    }
}
